var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankAcc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.25 13.5V28.5M8.25 13.5V28.5M3.75 13.5V28.5M27.75 13.5V28.5M3 31.5H33M0 35.25H36M18 16.5H16.5C16.1022 16.5 15.7206 16.658 15.4393 16.9393C15.158 17.2206 15 17.6022 15 18V18.5625C15 18.8871 15.1053 19.2029 15.3 19.4625C15.4947 19.7221 15.7684 19.9116 16.08 20.0025L19.92 21.123C20.2316 21.2139 20.5053 21.4034 20.7 21.663C20.8947 21.9226 21 22.2384 21 22.563V24C21 24.3978 20.842 24.7794 20.5607 25.0607C20.2794 25.342 19.8978 25.5 19.5 25.5H18M18 16.5H19.5C19.8978 16.5 20.2794 16.658 20.5607 16.9393C20.842 17.2206 21 17.6022 21 18V18.75M18 16.5V13.5M18 25.5H16.5C16.1022 25.5 15.7206 25.342 15.4393 25.0607C15.158 24.7794 15 24.3978 15 24V23.25M18 25.5V28.5M35.25 9.375V10.5H0.75V9.375C8.25 6.75 12.75 4.5 17.625 0.75H18.375C23.25 4.5 27.75 6.75 35.25 9.375Z",
    stroke: "#65C953",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankAcc);
export default __webpack_public_path__ + "static/media/bank-acc.e7ade1f5950cb3a4608a49cab214467b.svg";
export { ForwardRef as ReactComponent };